export default __webpack_public_path__ + "static/media/BeaujolaisAd.13934b62.jpg";